import { getI18n } from '@/common/i18n-provider';
import { getCurrentLanguageFromDocument } from 'common/locale-helper';
import { getLogger } from '@fileee/logger';

const logger = getLogger('setup-i18n');

const lang = getCurrentLanguageFromDocument();
logger.info('locale is: ' + lang);

const i18nOptions = {
  // Callback used when loading a single resource.
  customLoad: (language, namespace, callback) => {
    // i18next asks for region-tagged codes as well as short ones (with the default
    // `load: 'all'` a change to de-DE requests both 'de-DE' and 'de'), so branch on the
    // base subtag - matching 'de' exactly would serve the English bundle for 'de-DE'.
    const baseLanguage = String(language || '').split('-')[0];
    if (namespace === 'nsenterprise') {
      if (baseLanguage === 'de') {
        // @ts-ignore
        import(/* webpackChunkName: "nsenterprise-de" */ '../../locales/de/nsenterprise.json').then(
          (i18nJson) => {
            callback(null, i18nJson.default);
          }
        );
      } else if (baseLanguage === 'ja') {
        // @ts-ignore
        import(/* webpackChunkName: "nsenterprise-ja" */ '../../locales/ja/nsenterprise.json').then(
          (i18nJson) => {
            callback(null, i18nJson.default);
          }
        );
      } else if (baseLanguage === 'es') {
        // @ts-ignore
        import(/* webpackChunkName: "nsenterprise-ja" */ '../../locales/es/nsenterprise.json').then(
          (i18nJson) => {
            callback(null, i18nJson.default);
          }
        );
      } else {
        // @ts-ignore
        import(/* webpackChunkName: "nsenterprise-en" */ '../../locales/en/nsenterprise.json').then(
          (i18nJson) => {
            callback(null, i18nJson.default);
          }
        );
      }
    } else {
      if (baseLanguage === 'de') {
        // @ts-ignore
        import(/* webpackChunkName: "translation-de" */ '../../locales/de/translation.json').then(
          (i18nJson) => {
            callback(null, i18nJson.default);
          }
        );
      } else if (baseLanguage === 'ja') {
        // @ts-ignore
        import(/* webpackChunkName: "translation-ja" */ '../../locales/ja/translation.json').then(
          (i18nJson) => {
            callback(null, i18nJson.default);
          }
        );
      } else if (baseLanguage === 'es') {
        // @ts-ignore
        import(/* webpackChunkName: "translation-ja" */ '../../locales/es/translation.json').then(
          (i18nJson) => {
            callback(null, i18nJson.default);
          }
        );
      } else {
        import(/* webpackChunkName: "translation-en" */ '../../locales/en/translation.json').then(
          (i18nJson) => {
            callback(null, i18nJson.default);
          }
        );
      }
    }
  },
  lng: lang,
  attributes: ['t', 'i18n'],
  fallbackLng: 'de',
  pluralSeparator: '_',

  interpolation: {
    prefix: '{',
    suffix: '}'
  },
  debug: true
};

export async function setupI18n() {
  return getI18n().setup(i18nOptions);
}
